import React from "react";
import "../OfferstawqBreif/OfferstawqBreif.css";
import { Link } from "react-router-dom";

export default function OfferstawqBreif() {
  return (
    <>
      {/* HERO */}
      <div className="offers-breif">
        <div className="container-fluid">
            <div className="row">
    <div className="offers-hero d-flex align-items-center justify-content-center text-center mt-5 mb-5">
        <div className="hero-content text-white animate-slide pt-5 mt-5">
          <h1>عروض طوق النجاة</h1>
          <p>أفضل المنتجات بأفضل الأسعار… لأنك تستحق الأفضل</p>
        </div>
      </div>
<div className="" >
  <div className="container   ">

        {/* ABOUT */}
        <section className=" text-white  text-center ">
          <h2 className="section-title">عن طوق النجاة</h2>
          <p className="section-text">
            طوق النجاة هو وجهتك الأولى للحصول على أفضل المنتجات بجودة عالية وأسعار تنافسية.
            نوفر لك تجربة تسوق سهلة وممتعة مع مجموعة متنوعة من المنتجات.
          </p>
        </section>

        {/* MISSION */}
        <section className="text-center mb-5">
          <h2 className="section-title">رسالتنا</h2>
          <p className="section-text">
            نسعى لتقديم تجربة تسوق مميزة تجمع بين الجودة والسعر المناسب وسهولة الاستخدام،
            مع تقديم عروض مستمرة وخدمة عملاء مميزة.
          </p>
        </section>

        {/* OFFERS */}
        <section className=" pt-5 ">
          <h2 className="section-title text-center  pt-5 pb-5" >🔥 أحدث العروض</h2>

          <div className="row g-4 mobbreif" >

            <div className="col-md-4">
              <div className="offer-card text-center">
                <h4>خصومات</h4>
                <p>حتى 50% على منتجات مختارة</p>
              </div>
            </div>

            <div className="col-md-4">
              <div className="offer-card text-center">
                <h4>شحن سريع</h4>
                <p>توصيل سريع وآمن</p>
              </div>
            </div>

            <div className="col-md-4">
              <div className="offer-card text-center">
                <h4>منتجات أصلية</h4>
                <p>جودة عالية وضمان</p>
              </div>
            </div>

    

          </div>
        </section>

        {/* CTA */}

      </div>
</div>
    
            </div>
        </div>
      </div>
  
    </>
  );
}